import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { listDemandGroupMembers } from '@ebalance/proto/bffuser/v1/demand_group_service-DemandGroupService_connectquery'
import {
  ListDemandGroupMembersRequestSchema,
  type ListDemandGroupMembersResponse,
} from '@ebalance/proto/bffuser/v1/demand_group_service_pb'
import { type UseQueryResult, skipToken } from '@tanstack/react-query'

/**
 * 選んだ 1 グループの所属供給地点。未選択 (`undefined`) の間は取得しない。
 *
 * 取得失敗 (別の操作でグループが消えた NotFound 等) は右ペインに出し、一覧とエリア選択は
 * 残す。error boundary (全画面エラー) に飛ばすと一覧ごと消えるため、global QueryClient の
 * `throwOnError: true` を本 query だけ `false` に上書きする
 * (docs/guides/frontend-coding-guide.yaml「queries は throwOnError: true」からの意図的な逸脱。
 * 先例: useListDemandConfirmRecords)。
 */
export function useDemandGroupMembers(
  demandGroupId: string | undefined,
): UseQueryResult<ListDemandGroupMembersResponse, ConnectError> {
  return useQuery(
    listDemandGroupMembers,
    demandGroupId === undefined
      ? skipToken
      : create(ListDemandGroupMembersRequestSchema, { demandGroupId }),
    { throwOnError: false },
  )
}
